import { padNum } from '../common/common.util';
import { PeriodType } from '../widget/date-range.widget.model';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function createDateOptions(
    eventDate: Date,
    periodType: PeriodType,
    widgetId: number,
) {
    let date = null;
    if (eventDate) {
        date = `${eventDate.getFullYear()}-${padNum(
            eventDate.getMonth() + 1,
            2,
        )}-${padNum(eventDate.getDate(), 2)}`;
    }
    return {
        eventDate: date,
        dateRangeType: periodType,
        widgetId,
    };
}
